const __WEBPACK_NAMESPACE_OBJECT__ = require("zotero-api-client");